declare global {
  interface Set<T> {
    extend(other: Set<T>): void;

    sort_strings(): Set<string>;

    sort_numbers(): Set<number>;

    to_array(): Array<T>;

    is_equal(other: Set<T>): boolean;

    is_equal_values_and_order(other: Set<T>): boolean;

    is_empty(): boolean;
  }
}

Set.prototype.extend = function <T>(other: Set<T>): void {
  for (let item of other) {
    this.add(item);
  }
};

Set.prototype.sort_strings = function (): Set<string> {
  return new Set(this.to_array().sort((a: string, b: string) => a.localeCompare(b))); //js sort strings by default so we need to use sort by numbers
};

Set.prototype.sort_numbers = function (): Set<number> {
  return new Set(this.to_array().sort((a, b) => a - b)); //js sort strings by default so we need to use sort by numbers
};

Set.prototype.to_array = function <T>(): Array<T> {
  return Array.from(this);
};

Set.prototype.is_equal_values_and_order = function <T>(other: Set<T>): boolean {
  if (this.size !== other.size) return false;

  const iterator_this = this.values();
  const iterator_other = other.values();

  for (let i = 0; i < this.size; i++) {
    if (iterator_this.next().value !== iterator_other.next().value) {
      return false;
    }
  }

  return true;
};

Set.prototype.is_equal = function <T>(other: Set<T>): boolean {
  if (this.size != other.size) return false;

  let out = true;

  for (let item of this) {
    if (other.has(item)) continue;

    out = false;
    break;
  }

  return out;
};
Set.prototype.is_empty = function <T>(): boolean {
  return this.size == 0;
};

export {}; // This ensures TypeScript treats it as a module
